var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 83,
    viewBox: "0 0 95 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "clients-a",
    d: "M34.2857143,69.9622765 L34.2857143,54.753086 C34.2857143,39.6334388 46.4871848,30.4183811 61.5384615,30.4183811 C76.5897382,30.4183811 88.7912088,39.6334388 88.7912088,54.753086 L88.7912088,69.9622765 L88.7912088,69.9622765 M61.5384615,30.4183811 C69.9002819,30.4183811 76.6788767,23.6089945 76.6788767,15.2091905 C76.6788767,6.80938655 69.9002819,0 61.5384615,0 C53.1766412,0 46.3980464,6.80938655 46.3980464,15.2091905 C46.3980464,23.6089945 53.1766412,30.4183811 61.5384615,30.4183811 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clients-b",
    d: "M0,72.5996392 L0,57.3904486 C0,42.2708014 12.2014706,33.0557437 27.2527473,33.0557437 C42.304024,33.0557437 54.5054945,42.2708014 54.5054945,57.3904486 L54.5054945,72.5996392 L54.5054945,72.5996392 M27.2527473,33.0557437 C35.6145676,33.0557437 42.3931624,26.2463572 42.3931624,17.8465532 C42.3931624,9.44674919 35.6145676,2.63736264 27.2527473,2.63736264 C18.8909269,2.63736264 12.1123321,9.44674919 12.1123321,17.8465532 C12.1123321,26.2463572 18.8909269,33.0557437 27.2527473,33.0557437 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#clients-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#4E443D",
    strokeWidth: 6,
    xlinkHref: "#clients-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#clients-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#4E443D",
    strokeWidth: 6,
    xlinkHref: "#clients-b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#4E443D",
    strokeWidth: 6,
    d: "M33.6019536,79.6326062 L33.6019536,64.4234156 M57.8266178,79.6326062 L57.8266178,64.4234156 M18.4615385,79.6326062 L18.4615385,64.4234156 C18.4615385,49.3037685 30.663009,40.0887108 45.7142857,40.0887108 C60.7655624,40.0887108 72.967033,49.3037685 72.967033,64.4234156 L72.967033,79.6326062 L72.967033,79.6326062 M45.7142857,40.0887108 C54.0761061,40.0887108 60.8547009,33.2793242 60.8547009,24.8795202 C60.8547009,16.4797162 54.0761061,9.67032967 45.7142857,9.67032967 C37.3524653,9.67032967 30.5738706,16.4797162 30.5738706,24.8795202 C30.5738706,33.2793242 37.3524653,40.0887108 45.7142857,40.0887108 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.12375814bba3198bcb3652323b787d44.svg";
export { ForwardRef as ReactComponent };